import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import { ReturnStruct } from '@shared/services/structs/return.struct';
import { NFeSaidaAlterarTagsRequest } from '@shared/services/requests/repo-dfe/nfe-saida-alterar-tags.request';

@Injectable({ providedIn: 'root' })
export class NFeSaidaTagService extends CommonService {
  private readonly apiUrl = environment.urlApiRepoDFe + 'NFeSaidaTag';

  constructor(private httpClient: HttpClient) { super(); }

  public alterarTags(request: NFeSaidaAlterarTagsRequest): Observable<ReturnStruct> {
    return this.httpClient.patch<ReturnStruct>(`${this.apiUrl}/bulk`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
